import axios from "axios";
import config from "../config/config";
import { utils } from "../utils/utils";

export const handleError = (err) => {
  if (err?.response?.status === 401) {
    window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err;
  } else {
    window.location.href = "/error/500";
  }
};

export const inspectionPointsApi = {
  getInspectionSections: (data) => {
    const query = utils.buildQueryString(data);
    return axios(
      data.id
        ? `/api/crane-inspection-sections/${data.id}`
        : `/api/crane-inspection-sections?${query}`,
      {
        baseURL: config.apiURL,
        withCredentials: true,
        headers: { "web-version": process.env.REACT_APP_VERSION },
        method: "get",
      }
    )
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  getInspectionPoints: (data) => {
    const query = utils.buildQueryString(data);
    return axios(
      data.id
        ? `/api/crane-inspection-points/${data.id}`
        : `/api/crane-inspection-points?${query}`,
      {
        baseURL: config.apiURL,
        withCredentials: true,
        headers: { "web-version": process.env.REACT_APP_VERSION },
        method: "get",
      }
    )
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  createInspectionPoint: (data) => {
    return axios(`/api/crane-inspection-points`, {
      baseURL: config.apiURL,
      withCredentials: true,
      headers: { "web-version": process.env.REACT_APP_VERSION },
      method: "post",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  updateInspectionPoint: (data) => {
    return axios(`/api/crane-inspection-points/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      headers: { "web-version": process.env.REACT_APP_VERSION },
      method: "put",
      data,
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
  deleteInspectionPoint: (data) => {
    return axios(`/api/crane-inspection-points/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      headers: { "web-version": process.env.REACT_APP_VERSION },
      method: "delete",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err));
  },
};
